export class CustomFieldValue {
	constructor(
		public Id: number,
		public Value: any,
		public IsValid: boolean = true,
		public Text: string = null,
		public IsCustomValue: boolean = false,) {
	}
}